import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/api';

import { DossierNames, DossierPlaceholderUtils, PrimaryArticleIdentifierType, ProductionInEuType } from '../core';

@Injectable({
  providedIn: 'root'
})
export class EnumsService {
  valuesTranslated: Promise<any>;

  inEUTypes: SelectItem[] = [];
  primaryArticleIdentifier: SelectItem[] = [];

  // inEUTypes
  private euProducedText = 'enums.inEUTypes.EU_PRODUCED';
  private euImportedText = 'enums.inEUTypes.EU_IMPORTED';
  private euProducedAndImportedText = 'enums.inEUTypes.EU_PRODUCED_AND_IMPORTED';
  private noDataText = 'enums.inEUTypes.NO_DATA';

  // primaryArticleIdentifiers
  private paitVPNumber = 'enums.pait.VPNumber';
  private paitPINumber = 'enums.pait.PINumber';

  private readonly allSelectableDossierPlaceholderNames: DossierNames[] = [
    DossierNames.PRODUCTNAME,
    DossierNames.PRODUCTNUMBER,
    DossierNames.ORGANAME,
    DossierNames.PRODUCTDESCRIPTION,
    DossierNames.VP_PROJECT_NAME,
    DossierNames.VP_NUMBER,
    DossierNames.OTHER
  ];

  constructor(private translateService: TranslateService) {
    this.valuesTranslated = this.translateService
      .get([this.euProducedText, this.euImportedText, this.euProducedAndImportedText, this.noDataText, this.paitVPNumber, this.paitPINumber])
      .toPromise()
      .then((values: any) => {
        // inEUTypes
        this.inEUTypes.push({
          value: ProductionInEuType.EU_PRODUCED,
          label: values[this.euProducedText]
        });
        this.inEUTypes.push({
          value: ProductionInEuType.EU_IMPORTED,
          label: values[this.euImportedText]
        });
        this.inEUTypes.push({
          value: ProductionInEuType.EU_PRODUCED_AND_IMPORTED,
          label: values[this.euProducedAndImportedText]
        });
        this.inEUTypes.push({
          value: ProductionInEuType.NO_DATA,
          label: values[this.noDataText]
        });

        // primaryArticleIdentifier
        this.primaryArticleIdentifier.push({
          value: PrimaryArticleIdentifierType.VP_NUMBER,
          label: values[this.paitVPNumber]
        });
        this.primaryArticleIdentifier.push({
          value: PrimaryArticleIdentifierType.PI_NUMBER,
          label: values[this.paitPINumber]
        });
      });
  }

  filterDossierNames(event, alreadySelectedDossierNames: DossierNames[]): DossierNames[] {
    return this.allSelectableDossierPlaceholderNames
      .filter((dossierName: DossierNames) => !alreadySelectedDossierNames.includes(dossierName))
      .filter((dossierName: DossierNames) => {
        const translatedDossierName: string = this.translateService.instant(DossierPlaceholderUtils.getTranslationKey(dossierName));
        return translatedDossierName.toLowerCase().indexOf(event.query.toLowerCase()) >= 0;
      });
  }

  filterDossierRemarks(event, alreadySelectedDossierRemarks: DossierNames[]): DossierNames[] {
    return this.filterDossierNames(event, alreadySelectedDossierRemarks);
  }

  filterPait(event): any {
    const suggested: any[] = [];
    for (let i = 0; i < this.primaryArticleIdentifier.length; i++) {
      const singlePrimaryArticleIdentifier = this.primaryArticleIdentifier[i].label;
      if (singlePrimaryArticleIdentifier.toLowerCase().indexOf(event.query.toLowerCase()) === 0) {
        suggested.push(this.primaryArticleIdentifier[i]);
      }
    }
    return suggested;
  }

  filterInEUTypes(event): any {
    const suggested: SelectItem[] = [];
    for (let i = 0; i < this.inEUTypes.length; i++) {
      const singleEuType = this.inEUTypes[i];
      if (singleEuType.label.toLowerCase().indexOf(event.query.toLowerCase()) === 0) {
        suggested.push(singleEuType);
      }
    }
    return suggested;
  }

  getCategoryName(cats: any[]): string {
    const result: string[] = [];

    if (cats) {
      cats.forEach((value) => {
        result.push(value.identifier + ':' + value.text);
      });
      return result.join(', ');
    }
    return '';
  }
}
